export default "__VITE_ASSET__7cf98a63__"